import { render, staticRenderFns } from "./TtaPerformance.vue?vue&type=template&id=46fa4b6d&"
import script from "./TtaPerformance.vue?vue&type=script&lang=js&"
export * from "./TtaPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports